import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
	name: 'hasLieu'
})
export class HasLieuPipe implements PipeTransform {
	transform(consultation: any, ...args: any[]): boolean {
		return consultation && consultation.lieu && consultation.lieu.adresses && consultation.lieu.adresses.PRINCIPALE
	}

}
